import Server from '@/service/server'
import * as mutations from './mutations'

export default {
    namespaced: true,
    state: {
        subscriptionRequestResult: {
            subscriptionMethod: "",
            code: ""
        },
        isPinCodeSent: false,
        requestStatus: "None",
        registerModel: {},
        userInfo: {}
    },
    getters: {
        isPinCodeSent(state: any) {
            return state.isPinCodeSent;
        },
        cellOrEmailAsyncValidationMessage(state: any) {
            return state.cellOrEmailAsyncValidationMessage;
        },
        usernameAsyncValidationMessage(state: any) {
            return state.usernameAsyncValidationMessage;
        },
        registerModel(state: any) {
            return state.registerModel;
        },
        subscriptionRequestResult(state: any) {
            return state.subscriptionRequestResult;
        }
    },
    actions: {
        register(context: any, payload: any) {
            var emailRegexp = /([0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*@([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+[a-zA-Z]{2,9})/;
            var isEmail = emailRegexp.test(payload.uuId);

            var mobileRegexp = /\d{10,13}/;
            var isMobile = mobileRegexp.test(payload.uuId);

            var userManagement =
                context.rootGetters["tenantDesign/config"].userManagement;
            var planProviderCode = isEmail
                ? userManagement.email.planProviderCode
                : isMobile
                    ? userManagement.mobile.planProviderCode
                    : "";

            var requestPayload = {
                channel: "Portal",
                channelName: window.location.hostname,
                planProviderCode: planProviderCode,
                pageCode: "",
                clickId: "",
                campaign: ""
            };
            context.commit("setRequestPayload", requestPayload);
            var requestSubscription = context
                .dispatch("subscription/requestForSubscription", requestPayload, {
                    root: true
                })
                .then((requestResponse: any) => {
                    var requestResult = requestResponse.body.result;
                    context.commit("subscriptionRequestResultReceived", requestResult);
                    var initPayload = {
                        deviceType: payload.deviceType,
                        countryCode: context.state.subscriptionRequestResult.countryCode,
                        userName: payload.uuId,
                        code: context.state.subscriptionRequestResult.code,
                        password: payload.password,
                        confirm: payload.confirmPassword,
                        nickName: payload.userName,
                        isEmail: isEmail
                    };
                    context.commit("setRegisterModel", initPayload);
                    var promise = context
                        .dispatch("subscription/init", initPayload, {
                            root: true
                        })
                        .then((response: any) => {
                            context.commit("setIsPinCodeSent", true);
                        })
                        .catch(() => {
                            context.commit("setIsPinCodeSent", false);
                        });
                    return promise;
                })
                .catch(() => {
                    context.commit("setIsPinCodeSent", false);
                });

            return requestSubscription;
        },
        confirmPin(context: any, payload: any) {
            var promise = context.dispatch("subscription/verify", payload, {
                root: true
            });
            return promise;
        },
        checkRequestStatus(context: any, code: string) {
            var promise = context
                .dispatch("subscription/checkRequestStatus", code, { root: true })
                .then((result: any) => {
                    context.commit("requestStatusUpdated", result);
                    return result;
                });

            return promise;
        },
        getUserStatus(context: any, payload: any) {
            var promise = context.dispatch("subscription/getUserStatus", payload, {
                root: true
            });
        },
        checkUsernameExist(context: any, params: any) {
            var promise = Server.checkUsernameExist(params);
            return promise;
        },
        checkNicknameExist(context: any, params: any) {
            var promise = Server.checkNicknameExist(params);
            return promise;
        },
        resendPin(context: any, payload: any) {
            var requestSubscription = context
                .dispatch(
                    "subscription/requestForSubscription",
                    context.state.requestPayload,
                    {
                        root: true
                    }
                )
                .then((requestResponse: any) => {
                    var requestResult = requestResponse.body.result;
                    context.commit("subscriptionRequestResultReceived", requestResult);
                    var initPayload = {
                        deviceType: context.state.registerModel.deviceType,
                        countryCode: context.state.subscriptionRequestResult.countryCode,
                        userName: context.state.registerModel.userName,
                        code: context.state.subscriptionRequestResult.code,
                        password: context.state.registerModel.password,
                        confirm: context.state.registerModel.confirm,
                        nickName: context.state.registerModel.nickName,
                        isEmail: context.state.registerModel.isEmail
                    };
                    context.commit("setRegisterModel", initPayload);
                    var promise = context
                        .dispatch("subscription/init", initPayload, {
                            root: true
                        })
                        .then((response: any) => {
                            context.commit("setIsPinCodeSent", true);
                        })
                        .catch(() => {
                            context.commit("setIsPinCodeSent", false);
                        });
                    return promise;
                })
                .catch(() => {
                    context.commit("setIsPinCodeSent", false);
                });

            return requestSubscription;
        },
        setTrialPeriod(context:any, payload: any) {
            var requesterServiceRefCode = JSON.stringify(payload);
            var promise = Server.setTrialPeriod(requesterServiceRefCode).then((response: any) => {
              return response;
            })
            return promise;
        }

    },
    mutations: {
        setRequestPayload(state: any, requestPayload: any) {
            state.requestPayload = requestPayload;
        },
        setRegisterModel(state: any, registerModel: any) {
            state.registerModel = registerModel;
        },
        requestStatusUpdated(state: any, status: string) {
            state.requestStatus = status;
        },
        subscriptionRequestResultReceived(state: any, payload: any) {
            state.subscriptionRequestResult = payload;
        },
        userTokenSucceeded(state: any, token: any) {
            localStorage.setItem("userToken", JSON.stringify(token));
            state.isAuthenticatingUser = false;
            state.isUserAuthenticated = true;
            state.isUserAuthenticationFailed = false;
            state.userToken = token;
        },
        userTokenFailed(state: any) {
            state.isAuthenticatingUser = false;
            state.isUserAuthenticated = false;
            state.isUserAuthenticationFailed = true;
            localStorage.removeItem("userToken");
        },
        setIsPinCodeSent(state: any, payload: any) {
            state.isPinCodeSent = payload;
        }
    }
};
